module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('canvas', {
    ref: "canvas",
    style: (_vm.canvasStyle),
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ea86ce96", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ea86ce96!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Animation/index.vue
// module id = 893
// module chunks = 0